import { useTranslation } from "react-i18next";
import { ModalComponent, TypographyComponent } from "../../../gravity";

type InitDeletedDialogComponentProps = {
  userFullName: string;
  handleClick: () => void;
  isOpen: boolean;
};

export const InitDeletedDialogComponent = ({
  userFullName,
  handleClick,
  isOpen
}: InitDeletedDialogComponentProps) => {
  const { t } = useTranslation();

  return (
    <ModalComponent
      confirmLabel={t("Back to My Evaluations")}
      isOpen={isOpen}
      onConfirm={handleClick}
      size="small"
      title={t("This Evaluation Has Been Deleted")}
      cancelLabel=""
      onCancel={handleClick}
    >
      <TypographyComponent styling="p-default">
        {userFullName}
        {` `}
        {t("has deleted this evaluation and you no longer can view it.")}
      </TypographyComponent>
    </ModalComponent>
  );
};
